import React from 'react';
import { Link } from 'react-router-dom';
export function FiretreeLogo({
  className = ''
}: {
  className?: string;
}) {
  return <Link to="/" className={`flex items-center group ${className}`} aria-label="Firetree Home" data-id="element-26">
      <img src="https://cdn.magicpatterns.com/uploads/4cRGZvCEgXc9bffCWW1B64/logo-standard.svg" alt="Firetree" className="h-10 w-auto group-hover:opacity-80 transition-opacity" data-id="element-27" />
    </Link>;
}